/**
 * Notifications HTTP service (PX-W6.2) — the consumer-side verbs the bell and
 * the centre use. No create verb: rows are minted by the dispatcher/REST on
 * the SERVER (notifications canon); the client never posts a notification.
 *
 * Dismiss is a hard DELETE that publishes NO bus event — after it, unread
 * state is recomputed from server truth (the next list call), never drifted
 * locally.
 */

import { apiClient } from '@/services'

import type {
  ApiNotification,
  MarkAllReadResponse,
  NotificationsListResponse
} from './types'

export const notificationsHttp = {
  /** The org's persisted rows with the unread meta envelope. */
  list(severity?: string, status?: string): Promise<NotificationsListResponse> {
    return apiClient.get<NotificationsListResponse>('/{orgId}/notifications', {
      params: { severity: severity ?? '', status: status ?? '' }
    })
  },

  /** One row (deep-link reads). */
  get(id: string): Promise<ApiNotification> {
    return apiClient.get<ApiNotification>(`/{orgId}/notifications/${id}`)
  },

  /** Mark one row read; the response row is the reconciled server truth. */
  markRead(id: string): Promise<ApiNotification> {
    return apiClient.put<ApiNotification>(`/{orgId}/notifications/${id}/read`)
  },

  /** Mark every unread org row read; the response counts the updated rows. */
  markAllRead(): Promise<MarkAllReadResponse> {
    return apiClient.put<MarkAllReadResponse>('/{orgId}/notifications/mark-all-read')
  },

  /** Hard-delete one row (no bus event — the row is simply gone). */
  dismiss(id: string): Promise<void> {
    return apiClient.delete<void>(`/{orgId}/notifications/${id}`)
  }
}
